import React, { useState, useEffect } from "react";
import eliminationIcon from '../../../images/eliminationIcon.png'
import EliminationCard from './EliminationCard'
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

const EliminationBoard = (props) => {

    const { dataBoard } = props
    const [board, setBoard] = useState(dataBoard)

    useEffect(() => {
        setBoard(dataBoard);
    }, [dataBoard])

    const onDragEnd = (result) => {
        const { source, destination, draggableId } = result;

        // there is no destination
        if (!destination)
            return;

        // source and destination are the same
        if (destination.droppableId === source.droppableId && destination.index === source.index)
            return;

        const columnS = board[source.droppableId];

        const cards = columnS.cards;
        const card = cards.find(item => item.id === draggableId);
        cards.splice(source.index, 1);
        cards.splice(destination.index, 0, card);

        board[source.droppableId].cards = cards;
        setBoard(board);

        return;
    }

    const columnId = board.columnId;
    const column = board[columnId];
    const cards = column.cards;


    return (
        <DragDropContext
            onDragEnd={onDragEnd}
        >
            <div className="row w-100 m-0 mt-2 mr-n1 ml-n1 justify-content-center">
                {/* <GroupColumn key={board.columnId} column={board[board.columnId]} /> */}

                <div className="col-12 col-md-6 p-0 row-eq-height ">
                    <div className="bg-gray rounded-lg p-0 m-1 w-100 d-flex flex-column">
                        <span className="nav justify-content-center border-bottom p-2 font-weight-bolder rounded-top bg-bluegray">
                            {column.title}
                        </span>
                        <Droppable droppableId={columnId}>
                            {(provided, snapshot) => {
                                const bgClass = snapshot.isDraggingOver ? "bg-gray" : "bg-light"
                                return (
                                    <div className={"col pt-1 pb-1 pl-0 pr-0 border rounded-bottom " + bgClass}
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                    >
                                        {column.cards.map((card, i) => <EliminationCard key={card.id} card={card} index={i} isDraggingOver={snapshot.isDraggingOver} />)}
                                        {provided.placeholder}
                                    </div>
                                )
                            }}
                        </Droppable>
                    </div>
                </div >

                <div className="col-12 col-md-4 p-0 row-eq-height d-none d-md-flex">
                    <div className=" rounded-lg p-0 mt-4 m-1 w-100 d-flex flex-column justify-content-center align-items-center">
                        <img className="align-self-center mr-1" src={eliminationIcon} width="40%" alt="" />
                    </div>
                </div>
            </div>
        </DragDropContext>
    )
}

export default EliminationBoard;